import { apiService } from "../store";
import { messageError } from "./index";
import { getUser } from "./auth";

export const typeGroupsRequested = (data) => {
  return {
    type: "TYPE_GROUPS_REQUESTED",
    payload: data,
  };
};
export const statusTrainingChildren = (data) => {
  return {
    type: "STATUS_TRAINING_CHILDREN",
    payload: data,
  };
};
export const branchesLoaded = (newBranches) => {
  return {
    type: "BRANCHES_LOADED",
    payload: newBranches,
  };
};
export const branchesLoading = () => {
  return {
    type: "BRANCHES_LOADING",
  };
};
export const branchRequest = (data) => {
  return {
    type: "BRANCH_REQUEST",
    payload: data,
  };
};
export const branchesError = (error) => {
  return {
    type: "BRANCHES_ERROR",
    payload: error,
  };
};
export const updateBranch = (branch) => {
  return {
    type: "UPDATE_BRANCH",
    payload: branch,
  };
};
export const setBranchId = (id) => {
  return {
    type: "BRANCH_ID",
    payload: id,
  };
};
export const setGroupId = (id) => {
  return {
    type: "GROUP_ID",
    payload: id,
  };
};
export const groupRequested = (data) => {
  return {
    type: "GROUP_REQUEST",
    payload: data,
  };
};
export const groupsLoading = () => {
  return {
    type: "GROUPS_LOADING",
  };
};
export const groupsError = (error) => {
  return {
    type: "GROUPS_ERROR",
    payload: error,
  };
};
export const groupsLoaded = (newGroups) => {
  return {
    type: "GROUPS_LOADED",
    payload: newGroups,
  };
};
export const groupDiscountLoaded = (discount) => {
  return {
    type: "GROUP_DISCOUNT_LOADED",
    payload: discount,
  };
};
export const scheduleGroup = (schedule) => {
  return {
    type: "SCHEDULE_GROUP",
    payload: schedule,
  };
};
export const scheduleGroupRequest = () => {
  return {
    type: "SCHEDULE_GROUP_REQUEST",
  };
};
export const scheduleGroupLoading = (bool) => {
  return {
    type: "SCHEDULE_GROUP_LOADING",
    payload: bool,
  };
};
export const updateGroup = (group) => {
  return {
    type: "UPDATE_GROUP",
    payload: group,
  };
};

export const trainersRequested = (data) => {
  return {
    type: "TRAINERS_REQUEST",
    payload: data,
  };
};
export const trainersLoading = () => {
  return {
    type: "TRAINERS_LOADING",
  };
};
export const trainerRequest = (data) => {
  return {
    type: "TRAINER_REQUEST",
    payload: data,
  };
};
export const updateTrainer = (trainer) => {
  return {
    type: "UPDATE_TRAINER",
    payload: trainer,
  };
};
export const trainersError = (error) => {
  return {
    type: "TRAINERS_ERROR",
    payload: error,
  };
};
export const getAvatar = (photo) => ({
  type: "GET_PHOTO",
  payload: photo,
});
export const unmountAvatar = (photo) => ({
  type: "UNMOUNT_PHOTO",
  payload: photo,
});

export const typeGroupsRequest = () => (dispatch) => {
  apiService
    .typeGroupsRequest()
    .then((data) => {
      dispatch(typeGroupsRequested(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const stateTrainingChildren = () => (dispatch) => {
  apiService
    .stateTrainingChildren()
    .then((data) => {
      dispatch(statusTrainingChildren(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const fetchBranches = () => (dispatch) => {
  dispatch(branchesLoading());
  apiService
    .branchesRequest()
    .then((data) => {
      dispatch(branchesLoaded(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const branchLoaded = (id) => (dispatch) => {
  apiService
    .branchRequest(id)
    .then((data) => {
      dispatch(branchRequest(data));
      dispatch(fetchGroups);
      dispatch(trainersRequest);
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const branchCreate = (branch) => (dispatch) => {
  apiService
    .branchCreate(branch)
    .then((data) => {
      dispatch(branchRequest(data));
      dispatch(fetchBranches());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const branchDelete = (branch) => (dispatch) => {
  apiService
    .branchDelete(branch)
    .then(() => {
      dispatch(fetchBranches());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const branchUpdate = (branch) => (dispatch) => {
  apiService
    .updateBranch(branch)
    .then((data) => {
      dispatch(updateBranch(data));
      dispatch(fetchBranches());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const fetchGroups = () => (dispatch) => {
  dispatch(groupsLoading());
  apiService
    .groupsRequest()
    .then((data) => {
      dispatch(groupsLoaded(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const fetchDiscountGroup = () => (dispatch) => {
  apiService
    .discountsGroupRequest()
    .then((data) => {
      dispatch(groupDiscountLoaded(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const groupLoaded = (id) => (dispatch) => {
  apiService.groupRequest(id).then((data) => {
    const group = {
      ...data,
      children_ids: data?.children.map((item) => item?.id),
      children: data.children?.map((item) => ({
        ...item,
        full_name: `${item.last_name} ${item.first_name} ${
          item.middle_name !== null ? item.middle_name : ""
        }`,
      })),
    };
    dispatch(groupRequested(group));
  });
  /*.catch(err => {
      dispatch(messageError(err.response.data.message));
    });*/
};
export const groupDelete = (group) => (dispatch) => {
  apiService
    .groupDelete(group)
    .then((data) => {
      dispatch(fetchGroups(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const groupCreate = (group) => (dispatch) => {
  apiService
    .createGroup(group)
    .then((data) => {
      dispatch(groupRequested(data));
      dispatch(fetchGroups(group.id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const groupUpdate = (group) => (dispatch) => {
  apiService
    .updateGroup(group)
    .then(() => {
      dispatch(groupLoaded(group.id));
      dispatch(fetchGroups());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const requestGroupSchedule = (id, children_id, payload = undefined) => (dispatch) => {
  dispatch(scheduleGroupRequest());
  apiService
    .groupSchedule(id, children_id, payload)
    .then((data) => {
      dispatch(scheduleGroup(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const requestGroupScheduleForClient = (id) => (dispatch) => {
  dispatch(scheduleGroupLoading(true));
  apiService
    .groupScheduleForClient(id)
    .then((data) => {
      dispatch(scheduleGroup(data));
      dispatch(scheduleGroupLoading(false));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
      dispatch(scheduleGroupLoading(false));
    });
};
export const requestGroupScheduleForClientTraining = (id) => (dispatch) => {
  dispatch(scheduleGroupLoading(true));
  apiService
    .groupScheduleForClientTraining(id)
    .then((data) => {
      dispatch(scheduleGroup(data));
      dispatch(scheduleGroupLoading(false));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
      dispatch(scheduleGroupLoading(false));
    });
};

export const requestGroupScheduleForAdminInvoice =
  (id, startDate) => (dispatch) => {
    dispatch(scheduleGroupLoading(true));
    apiService
      .groupScheduleForAdminInvoice(id, startDate)
      .then((data) => {
        dispatch(scheduleGroup(data));
        dispatch(scheduleGroupLoading(false));
      })
      .catch((err) => {
        dispatch(messageError(err.response.data.message));
        dispatch(scheduleGroupLoading(false));
      });
  };

export const trainersRequest = () => (dispatch) => {
  dispatch(trainersLoading());
  apiService
    .trainersRequest()
    .then((data) => {
      const trainers = data.map((item) => ({
        ...item,
        full_name: `${item.last_name} ${item.first_name} ${
          item.middle_name !== null ? item.middle_name : ""
        }`,
      }));
      dispatch(trainersRequested(trainers));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const trainerLoaded = (id) => (dispatch) => {
  apiService
    .trainerRequest(id)
    .then((data) => {
      const trainer = {
        ...data,
        full_name: `${data.last_name} ${data.first_name} ${data.middle_name}`,
      };
      dispatch(trainerRequest(trainer));
      dispatch(fetchGroups);
      dispatch(fetchBranches);
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const trainerCreate = (trainer) => (dispatch) => {
  apiService
    .trainerCreate(trainer)
    .then((data) => {
      dispatch(trainerRequest(data));
      dispatch(trainersRequest(trainer.id));
      if (trainer.photo.file) {
        dispatch(
          savePhoto(trainer.photo.file, trainer.photo.collection, data.id)
        );
      }
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const trainerDelete = (trainer) => (dispatch) => {
  apiService
    .trainerDelete(trainer)
    .then(() => {
      dispatch(trainersRequest());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const trainerUpdate = (trainer) => (dispatch) => {
  trainer.phone = trainer.phone.replace(/\D+/g, "");
  return apiService
    .updateTrainer(trainer)
    .then((data) => {
      dispatch(trainerRequest(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const savePhoto = (file, collection, id) => () => {
  apiService.savePhoto(file, collection, id).then(() => {});
};
export const savePhotoOffice = (file, collection, id) => (dispatch) => {
  apiService.savePhoto(file, collection, id).then(() => {
    dispatch(getUser());
  });
};

export const deleteMedia = (collection, id, mediaID) => (dispatch) => {
  apiService.delMedia(collection, id, mediaID).then(() => {
    dispatch(getUser());
  });
};

export const getPhoto = (collection, id) => async (dispatch) => {
  apiService.getPhoto(collection, id).then((data) => {
    const urlPhoto = data.length && data[0].full_url;
    dispatch(getAvatar(urlPhoto));
  });
};
